import * as React from 'react';

import './SingleSpaContainer.scss';
import { NewRequestBackground } from '../newRequestBackground/NewRequestBackground';

interface ISingleSpaContainerProps {
    showTemplateScreen: boolean | null;
    showTemplatesMicro: boolean;
}

export const SingleSpaContainer = ({ showTemplateScreen, showTemplatesMicro }: ISingleSpaContainerProps) => {
    return (
        <>
            <div className="single-spa__container" id="single-spa__container"></div>
            {showTemplatesMicro && (
                <div className="single-spa__invisibleContainer" id="single-spa__container:templates"></div>
            )}
            {showTemplateScreen === false ? <NewRequestBackground /> : ''}
        </>
    );
};
